// extracted by mini-css-extract-plugin
export default {"loader":"loader-table_loader__zIfWz","l2":"loader-table_l2__wroZW","textloader":"loader-table_textloader__WZNP3"};